import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';

const TopSearchAddEdit = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const numProps = (e) => ['e','E','+','-'].includes(e.key) && e.preventDefault()

    const schema = yup.object({
        name: yup.string().required("Name is required"),
        order: yup.number().transform((value, originalValue) => originalValue === "" ? null : value).nullable().required("Order is required"),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            name: '',
            order: '',
            isActive: '',
        })
    }

    useEffect(() => {
        isEdit && getTopSearch()
    }, [])

    const getTopSearch = () => {
        ApiHelper.get(`${API_ENDPOINTS.TOP_SEARCH}/${id}`).then((res) => {
            if (res.status === 200) {
                reset({
                    name:res.data.data.name,
                    order:res.data.data.order,
                    isActive:res.data.data.isActive,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);  
        })
    }
      
    const onSubmit = (data) => {
        if (isEdit) {
           update(data) 
        } else {
            add(data)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.TOP_SEARCH}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({severity:'success', summary: 'Success', detail:res.data.message , life:3000})
                setTimeout(() => {
                    navigate('/top-search')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({severity:'error', summary: 'Error', detail:error.response.data.message , life:3000})
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.TOP_SEARCH}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({severity:'success', summary: 'Success', detail:res.data.message , life:3000})
                setTimeout(() => {
                    navigate('/top-search')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({severity:'error', summary: 'Error', detail:error.response.data.message , life:3000})
        })
    };

  return (
    <>
        <Toast ref={toast}/>
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/top-search`)}> Top Search </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                            </span>
                        </h4>
                        <Link to="/top-search" class="btn btn-secondary">⬅ Go Back</Link>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                <form id="adminUserForm" onSubmit={handleSubmit(onSubmit)}>
                                        <div class="row mb-3">
                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Name</label>
                                                <input type="text" name="name" class="form-control" {...register("name")} />
                                                <small className="text-danger">{errors.name?.message}</small>
                                            </div>

                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Order</label>
                                                <input type="number" onKeyDown={numProps} name="order" class="form-control" {...register("order")}/>
                                                <small className="text-danger"> {errors.order?.message} </small>
                                            </div>

                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Status</label>
                                                <div class="form-check form-switch mb-2">
                                                    <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <button type="submit" class="btn btn-primary me-3">Save</button>
                                            <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default TopSearchAddEdit
